import { ERROR_MESSAGES, IFamilyGroupManagementError, MANAGEMENTFIELDS as FIELDS } from "../../../../Interfaces/IFamilyGroupManagementFormField";
import { IValidationRules } from "../../../../Interfaces/IValidationRule";
import { getFamilyGroupManagement } from "../../../../Service-Utils/helper";
import { IFamilyGroupManagementFormValueType } from "../../../../Types/familyGroupManagementFormProps";

const IsNullEmptyUndefined = (value: any) => {
  if (typeof value === "string") {
    return value?.trim() === "";
  }

  return value === undefined || value === null;
}


const required = (
  value: any,
  formValues: any,
  field: any,
  ruleConfig?: any | undefined
) => {

  if (ruleConfig?.validateOn != undefined) {
    if (!ruleConfig.validateOn(value, formValues)) {
      return { valid: true, errorMessage: "" };
    }
  }

  const isValid = !IsNullEmptyUndefined(value);
  return {
    valid: isValid,
    errorMessage: isValid ? "" : ERROR_MESSAGES.required,
  };
};

const alphanumeric = (value: any, formValues: any, field: any) => {
  if (IsNullEmptyUndefined(value)) {
    return { valid: true, errorMessage: "" };
  }
  const isValid = RegExp("^[a-zA-Z0-9 \/-]*$").test(value);
  return {
    valid: isValid,
    errorMessage: isValid ? "" : ERROR_MESSAGES.alphanumeric,
  };
};

const charLength = (value: any, formValues: any, field: any, ruleConfig?: any | undefined) => {
  if (IsNullEmptyUndefined(value)) {
    return { valid: true, errorMessage: "" };
  }
  const isValid = (value.length >= ruleConfig.minLength) && (value.length <= ruleConfig.maxLength);
  return {
    valid: isValid,
    errorMessage: isValid ? "" : ERROR_MESSAGES.charLength(ruleConfig.minLength, ruleConfig.maxLength),
  };
};

/*Validations*/
/*Rules*/
const rules = {
  required,
  alphanumeric,
  charLength
};


export const validateDuplicate = async (formValues: any, previousValues: any) => {
  let isValid = true;

  if (previousValues?.data?.editPayload?.values.FamilyGroup === formValues[FIELDS.FamilyGroup.name] && previousValues?.data?.editPayload?.values?.ProductType === formValues[FIELDS.ProductType.name]) {
    return {
      valid: true,
      error: { FamilyGroup: undefined }
    };
  }

  const familyGroup = await getFamilyGroupManagement(formValues[FIELDS.FamilyGroup.name], formValues[FIELDS.ProductType.name])
  isValid = await familyGroup?.length === 0;
  return {
    valid: isValid,
    error: { FamilyGroup: isValid ? undefined : ERROR_MESSAGES.duplicate }
  };
};

export const validateField = (field: string, value: any, formValues: any) => {
  let result = true;
  const errors = { [field]: "" };
  Object.keys(FIELDS[field as keyof typeof FIELDS].rules).forEach(
    (rule) => {

      if (!result) {
        return;
      }

      const fieldResult = rules[rule as keyof typeof rules](
        value,
        formValues,
        field,
        (FIELDS[field as keyof typeof FIELDS]?.rules as IValidationRules)?.[rule as keyof typeof rules]
      );

      if (!fieldResult.valid) {
        result = false;
        errors[field] = fieldResult?.errorMessage;
      }
    }
  );

  return { result, errors };
};

export const validateForm = (values: IFamilyGroupManagementFormValueType) => {
  let result = true;
  const errors: IFamilyGroupManagementError = {
    FamilyGroup: undefined,
    UpdatedDate: undefined,
    CreatedDate: undefined,
    UpdatedBy: undefined,
    ProductType: undefined,
    LPFamilyGroupMix: undefined,
    MLPFamilyGroupMix: undefined,
    SerialControl: undefined,
    SerialInputMask: undefined,
    StrapTotes: undefined
  };

  Object.keys(FIELDS).forEach((field) => {
    const fieldResult = validateField(
      field,
      values[field as keyof typeof FIELDS],
      values,
    );

    if (!fieldResult.result) {
      result = false;
      errors[field as keyof typeof FIELDS] = fieldResult.errors[field];
    }

  });
  return { result, errors };
};